import { Injectable } from '@angular/core';
import {ToastData, ToastOptions, ToastyService} from 'ng2-toasty';
import { Observable, Subject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class ToastService {

  position = 'top-right';
  title: string;
  msg: string;
  showClose = true;
  theme = '';
  type = '';
  closeOther = false;
  private subject = new Subject<any>();

  constructor(private toastyService: ToastyService) { }

  addToast(options) {

    if (options.closeOther) {
      this.toastyService.clearAll();
    }
    this.position = options.position ? options.position : this.position;
    this.setPosition();

    const toastOptions: ToastOptions = {
      title: options.title,
      msg: options.msg,
      showClose: options.showClose,
      timeout: options.timeout,
      theme: options.theme,
      onAdd: (toast: ToastData) => {
        /* added */
      },
      onRemove: (toast: ToastData) => {
        /* removed */
      }
    };

    switch (options.type) {
      case 'default': this.toastyService.default(toastOptions); break;
      case 'info': this.toastyService.info(toastOptions); break;
      case 'success': this.toastyService.success(toastOptions); break;
      case 'wait': this.toastyService.wait(toastOptions); break;
      case 'error': this.toastyService.error(toastOptions); break;
      case 'warning': this.toastyService.warning(toastOptions); break;
    }
  }

  getPosition(): Observable<any> {
    return this.subject.asObservable();
  }

  setPosition() {
    this.subject.next({
      'position': this.position
    });
  }
}
